import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

function TeleAppointmentBooked(props: any) {
  const [t] = useTranslation();
  const brandName = localStorage.getItem("brandName");
  return (
    <>
      <div className="modal-body px-4 pt-0 pb-1 text-center">
        <div className="position-relative d-flex justify-content-center align-items-center">
          <img
            src="/assets/images/check-2.png"
            className="my-4"
            style={{ height: 120 }}
            alt="check"
          />
          <img
            src="/assets/images/Animation.gif"
            className="position-absolute"
            style={{ height: 120 }}
            alt="anim"
          />
        </div>

        <h4 className="mb-2 mt-0">{t("Your Request has been submitted")} </h4>
        {props.selectedPaymentMode === "by insurance" ? (
          <>
            <p className="text-dark mb-0 fw-500 mt-2 fs-14">
              {brandName === "llh"
                ? t(
                    "LLH team will connect you for further details & Consultation fees."
                  )
                : t(
                    "Burjeel team will connect you for further details & Consultation fees."
                  )}
            </p>
            <p className="text-dark fw-500 fs-14">
              {t(
                " Consultation fees will be subjected to your insurance provider."
              )}
            </p>
          </>
        ) : (
          <p className="text-dark mb-0 fw-500 mt-2 fs-14">
            {t("Please complete your payment in the next page")}
          </p>
        )}

        <div className="p-2 bg-lightgray mt-4">
          <div className="d-flex justify-content-between align-items-center border-bottom">
            <p className="fw-bold fs-18">{t("Appointment Reference Number")}</p>
            <p className="fs-18">{props.apptRefNumber}</p>
          </div>
          <div className="d-flex justify-content-between align-items-center border-bottom">
            <p className="fw-bold fs-18">{t("Appointment with")}</p>
            <p className="fs-18">{props.doctorName}</p>
          </div>
          <div className="d-flex justify-content-between align-items-center border-bottom">
            <p className="fw-bold fs-18">{t("Patient Name")}</p>
            <p className="fs-18">{props.patientName}</p>
          </div>
          <div className="d-flex justify-content-between align-items-center border-bottom">
            <p className="fw-bold fs-18">{t("Appointment Date")}</p>
            <p className="fs-18">{props.apptDate}</p>
          </div>
          <div className="d-flex justify-content-between align-items-center">
            <p className="fw-bold fs-18">{t("Appointment Time")}</p>
            <p className="fs-18">{props.apptTime}</p>
          </div>
        </div>

        <div className="p-4">
          <Link
            to="/auth/TeleconsultationAppointments"
            className="btn btn-primary no-focus px-5 btn-primary-linear"
          >
            {t("View Appointment")}
          </Link>
        </div>
      </div>
    </>
  );
}

export default TeleAppointmentBooked;
